import {
  ModalDialog,
  ModalMessage,
  WarningInfoIcon,
  ModalMessageColorsEnum,
} from '@acceso/design-system';

type ConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onAction: () => void;
  heading: string;
  title: string;
  actionLabel: string;
  cancelLabel: string;
  description?: string;
};

/**
 * Generic confirmation dialog. Every label is supplied by the caller on purpose:
 * a shared default here silently changed the clips modal's button text when this
 * component was extracted, so there is nothing left to inherit by accident.
 */
export function ConfirmationModal({
  isOpen,
  onClose,
  onAction,
  heading,
  title,
  actionLabel,
  cancelLabel,
  description,
}: ConfirmationModalProps) {
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      onAction={onAction}
      heading={heading}
      actionLabel={actionLabel}
      linkLabel={cancelLabel}
      color={ModalMessageColorsEnum.WARNING}
    >
      <ModalMessage title={title} description={description} icon={WarningInfoIcon} />
    </ModalDialog>
  );
}
